// for the subMenus
import AdminIcon from '@material-ui/icons/Lock';
import CurriculumIcon from '@material-ui/icons/School';
import LibraryIcon from '@material-ui/icons/VideogameAsset';
import avatars from './avatars';
import badges from './badges';
import courses from './courses';
import curriculum_activities from './curriculum_activities';
import guide_ranks from './guide_ranks';
import launched_apps from './launched_apps';
import learning_paths from './learning_paths';
import library_categories from './library_categories';
import library_engines from './library_engines';
import library_keyrings from './library_keyrings';
import library_objects from './library_objects';
import library_widgets from './library_widgets';
import log_entries from './log_entries';
import missions from './missions';
import organizations from './organizations';
import project_categories from './project_categories';
import ranks from './ranks';
import users from './users';

export default {
  resources: {
    organizations,

    // admin subMenu
    users,
    log_entries,

    // curriculum subMenu
    ranks,
    guide_ranks,
    learning_paths,
    missions,
    badges,
    curriculum_activities,
    avatars,
    launched_apps,
    project_categories,
    courses,

    // library
    library_widgets,
    library_engines,
    library_categories,
    library_objects,
    library_keyrings
  },
  subMenus: [
    {
      name: 'Admin',
      Icon: AdminIcon,
      resourceNames: [
        'users',
        'log_entries',
      ],
    },
    {
      name: 'Curriculum',
      Icon: CurriculumIcon,
      resourceNames: [
        'ranks',
        'guide_ranks',
        'learning_paths',
        'missions',
        'badges',
        'curriculum_activities',
        'launched_apps',
        'project_categories',
        'avatars',
        'courses',
      ],
    },
    {
      name: 'Library',
      Icon: LibraryIcon,
      resourceNames: [
        'library_widgets',
        'library_engines',
        'library_categories',
        'library_objects',
        'library_keyrings',
      ],
    },
  ],
};
